// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Eco: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 19 20" enableBackground="new 0 0 19 20" xmlSpace="preserve" fill="currentColor">
<path fillRule="evenodd" clipRule="evenodd" d="M10.83,12.49c0,0,2.61-6.37,4.93-9.12c1.14,0.47,8.61,13.84-5.15,16.46
	c0,0,4.98-4.13,5.49-11.22c-0.42,0.59-1.39,5.86-5.19,9.75C11.39,15.87,11.46,14.37,10.83,12.49"/>
<path fillRule="evenodd" clipRule="evenodd" d="M10.19,19.11c0,0,4.26-12.91-10-7.72c0.42,0.76,4.09,6.96,9.28,8.61
	c0.13-1.22-1.52-5.7-5.78-7.76C4.07,12.02,8.13,12.83,10.19,19.11"/>
<path fillRule="evenodd" clipRule="evenodd" d="M10.61,11.6c0,0,2.05-4.6,2.59-5.19C12.74,4.81,8.76,1.05,4.79,0
	c0,0-0.63,3.88,1.39,9.64c0.91-0.15,2.62,0.4,3.71,1.39c-0.08-0.84-0.72-4.49-2.24-7.19C8.08,3.97,10.14,7.98,10.61,11.6"/>
</svg>;
};

export default React.memo(Eco);
